import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { validatePageContent, type PageContent } from "./schema";

export interface LivePage { page_id: string; kind: "native" | "custom"; key: string; title: string; revision_id: string; published_at: string | null; content: PageContent }

/** Reads only the approved live snapshot (server-side RPC); drafts are never exposed to visitors. */
export async function fetchLivePage(kind: "native" | "custom", key: string): Promise<LivePage | null> {
  const { data, error } = await supabase.rpc("get_live_page", { _kind: kind, _key: key });
  if (error || !data) return null;
  const page = data as unknown as LivePage;
  const valid = validatePageContent(page.content);
  // A snapshot that no longer validates on the client falls back to the built-in page instead of rendering.
  return valid.ok ? { ...page, content: valid.content } : null;
}

export function useLivePage(kind: "native" | "custom", key: string | undefined) {
  return useQuery({
    queryKey: ["live-page", kind, key],
    queryFn: () => fetchLivePage(kind, key!),
    enabled: !!key,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
